import { cn } from '../lib/utils';

interface SignalLogoProps {
  /** Size of the rounded gradient mark in pixels. */
  size?: number;
  className?: string;
}

export function SignalLogo({ size = 26, className }: SignalLogoProps) {
  const glyphSize = Math.round(size * 0.58);

  return (
    <span
      aria-hidden
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.27) }}
      className={cn(
        'flex shrink-0 items-center justify-center bg-[linear-gradient(135deg,#0071E3,#5AC8FA)]',
        className,
      )}
    >
      <svg width={glyphSize} height={glyphSize} viewBox="0 0 24 24" fill="none">
        <rect x="3" y="14" width="2.6" height="6" rx="1.1" fill="#fff" opacity="0.35" />
        <rect x="7.4" y="10" width="2.6" height="10" rx="1.1" fill="#fff" opacity="0.5" />
        <rect x="11.8" y="13" width="2.6" height="7" rx="1.1" fill="#fff" opacity="0.35" />
        <rect x="16.6" y="4" width="3.2" height="16" rx="1.4" fill="#fff" />
      </svg>
    </span>
  );
}
